import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-428eede5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fdd-dialog" }
const _hoisted_2 = { class: "fdd-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fdd-title" }, "因子说明", -1))
const _hoisted_4 = { class: "fdd-body" }
const _hoisted_5 = { class: "fdd-group" }
const _hoisted_6 = { class: "fdd-factor-name" }
const _hoisted_7 = {
  key: 0,
  class: "fdd-opt-name"
}
const _hoisted_8 = {
  key: 1,
  class: "fdd-opt-desc"
}
const _hoisted_9 = {
  key: 1,
  class: "fdd-opt-card"
}
const _hoisted_10 = { class: "fdd-opt-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fdd-mask",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("span", {
                class: "fdd-close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tree, (node) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: node.attrCode
                }, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(node.attrName), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(node.factors, (factor) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: factor.attrCode
                    }, [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(factor.attrName), 1),
                      (factor.options && factor.options.length)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(factor.options, (opt) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: opt.attrCode,
                              class: "fdd-opt-card"
                            }, [
                              (opt.attrName)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(opt.attrName), 1))
                                : _createCommentVNode("", true),
                              (opt.attrDesc)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(opt.attrDesc), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        : (factor.attrDesc)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, _toDisplayString(factor.attrDesc), 1)
                            ]))
                          : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ], 64))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}